import { t, Trans } from '@lingui/macro';
import { Button, Input, PasswordInput, TextInput } from '@mantine/core';
import { isNotEmpty, useForm } from '@mantine/form';
import { observer } from 'mobx-react-lite';
import { IMaskInput } from 'react-imask';
import { Lock, MessageCode, User } from 'tabler-icons-react';

type Fields = {
  phone: string;
  password: string;
  code: string;
};

type ChangePassFormProps = {
  initialValues: { phone: Fields['phone'] };
  onSubmit: (fields: Fields) => void;
};
export const ChangePassForm = observer(
  ({ initialValues, onSubmit }: ChangePassFormProps) => {
    const form = useForm({
      initialValues: {
        phone: initialValues.phone,
        password: '',
        code: '',
      },

      validate: {
        password: isNotEmpty(t`Пожалуйста, заполните поле`),
        code: isNotEmpty(t`Пожалуйста, заполните поле`),
      },
    });

    return (
      <form onSubmit={form.onSubmit(onSubmit)}>
        <Input.Wrapper
          label={<Trans>Номер телефона</Trans>}
          {...form.getInputProps('phone')}
        >
          <Input<any>
            disabled
            size="lg"
            icon={<User size="1rem" />}
            component={IMaskInput}
            placeholder="374 01 234 567"
            mask="{374} 00 000 000"
            value={form.getInputProps('phone').value}
            onBlur={form.getInputProps('phone').onBlur}
            onFocus={form.getInputProps('phone').onFocus}
            error={form.getInputProps('phone').error}
            onAccept={(_: any, mask: { unmaskedValue: string }) => {
              form.getInputProps('phone').onChange(mask.unmaskedValue);
            }}
          />
        </Input.Wrapper>

        <TextInput
          size="lg"
          mt={8}
          label={<Trans>Код подтверждения</Trans>}
          autoComplete="one-time-code"
          inputMode="numeric"
          icon={<MessageCode size="1rem" />}
          {...form.getInputProps('code')}
        />

        <PasswordInput
          size="lg"
          mt={8}
          label={<Trans>Новый пароль</Trans>}
          autoComplete="new-password"
          icon={<Lock size="1rem" />}
          {...form.getInputProps('password')}
        />

        <Button size="lg" mt="xl" fullWidth type="submit">
          <Trans>Отправить код</Trans>
        </Button>
      </form>
    );
  }
);

ChangePassForm.displayName = 'ChangePassForm';
